import http from './http';
import { authHeader, oioHeader } from '@/utils';
import { API_URL, USER_URL, SEARCH_URL } from '@/constants/config';

const currentUser = USER_URL + '/users';
const base = API_URL + '/v1/1/4/1';
const baseSearch = SEARCH_URL + '/v1/1/4/4/search/user';

class UserService {
  /**
   * Get logged in user info
   */
  async me() {
    try {
      const { data: result } = await http.get(`${currentUser}/me`, {
        headers: { ...authHeader(), ...oioHeader() }
      });
      return result.data;
    } catch (e) {
      throw new Error(e);
    }
  }

  /**
   * All users
   */
  async all({ perPage = 50, page = 1 } = {}) {
    const params = `?page=${page}&perPage=${perPage}`;
    const { data: result } = await http.get(`${base}/user/getUsers${params}`, { headers: authHeader() });
    return { data: result.data.users, count: result.data.count };
  }

  /**
   * Banned users
   */
  async getBanned({ perPage = 50, page = 1 } = {}) {
    const params = `?page=${page}&perPage=${perPage}`;
    const { data: result } = await http.get(`${base}/users/banned${params}`, {
      headers: { ...authHeader(), ...oioHeader() }
    });
    return { data: result.data.users, count: result.data.allBannedDioUsersCount };
  }

  /**
   * Get by verify status
   *
   * @param {id: string, page: int. perPage: int } params
   */
  async getByVerifyStatus({ status = false, perPage = 50, page = 1 } = {}) {
    const params = `?isVerified=${status}&page=${page}&perPage=${perPage}`;
    const { data: result } = await http.get(`${base}/users/list/adminVerified${params}`, {
      headers: { ...authHeader(), ...oioHeader() }
    });
    return { data: result.data.users, count: result.data.count };
  }

  /**
   * Verify a user
   * @param {*} id
   *
   */
  async verify(userId) {
    const body = { userId, isAdminVerified: true };
    const { data: result } = await http.post(`${base}/users/verify/adminVerified`, body, {
      headers: { ...authHeader(), ...oioHeader() }
    });
    return result.data;
  }

  /**
   * Search users
   *
   * @param {{search, page: int. perPage: int}} params
   */
  async search({ search = '', perPage = 50, page = 1 }) {
    const params = `?page=${page}&perPage=${perPage}&q=${search}`;
    const { data: result } = await http.get(`${baseSearch}${params}`, {});
    return { data: result.data.paginatedSearchResult, count: result.data.totalCount };
  }
}
export default new UserService();
